import gql from 'graphql-tag';

export const MEMBER_CREATE_QUERY = gql`
  mutation CreateMember($member: MemberCreateInput) {
    createMember(member: $member) {
      id
      firstName
      lastName
      username
    }
  }
`;

export const MEMBER_UPDATE_MUTATION = gql`
  mutation updateMember($member: MemberUpdateInput) {
    updateMember(member: $member) {
      id
      firstName
      lastName
      username
    }
  }
`;

export const ACTIVE_MEMBER_UPDATE_MUTATION = gql`
  mutation UpdateActiveMember($member: MemberUpdateInput) {
    updateMember(member: $member) {
      archivedOn
      canSurvey
      certifiedEmail
      createdOn
      deletedOn
      email
      emailVerificationRequired
      firstName
      gustoEmployeeId
      id
      imageId
      imageUrl
      lastAccess
      lastName
      memberGroupId
      memberNumber
      memberSettings
      organizationId
      pendingEmail
      phone
      positionId
      submittedOn
      timeLocationRequired
      updatedOn
      username
      usernameUnique
      verifiedEmail
      organization {
        authoritativeSignature
        betaTester
        createdOn
        defaultBreakDuration
        defaultEndTime
        defaultStartTime
        deletedOn
        demo
        disclaimer
        id
        imageId
        inRecoveryMode
        gustoCompanyId
        lockOnSelfSignature
        minimumAppVersion
        organizationInfo {
          id
          organizationId
          longitude
          latitude
          address1
          address2
          city
          county
          state
          postalCode
          country
          phone
          trade
          currencyCode
          employeeMin
          employeeMax
          createdOn
          submittedOn
          updatedOn
          deletedOn
        }
        organizationPayPeriod {
          id
          organizationId
          payPeriodType
          startDate
          dayOne
          dayTwo
          createdOn
          submittedOn
          updatedOn
          deletedOn
        }
        organizationOvertimePeriods {
          id
          organizationId
          startTime
          lengthInDays
          weeklyOvertime
          dailyOvertime
          dailyDoubletime
          seventhDayOvertime
          seventhDayDoubletime
          saturdayMultiplier
          sundayMultiplier
          createdOn
          submittedOn
          updatedOn
          deletedOn
        }
        organizationName
        overtimeFlag
        ownedBy
        requireCostCode
        requireProject
        revokedOn
        safetySignature
        safetySignatureMessage
        signatureDate
        stripeAccountCreatedOn
        stripeAccountStatus
        stripeAccountType
        stripeCustomerId
        submittedOn
        breakPolicy
        breakPolicyCalifornia
        breakPolicyMessage
        timeAccuracy
        timeAccuracyMessage
        timeRounding
        timeRoundingInterval
        timeRoundingType
        totalTimeFlag
        trackBudgets
        trackBudgetCost
        trackBudgetEquipmentCosts
        trackBudgetEquipmentHours
        trackBudgetProgress
        trackBudgetProgressValue
        trackCostCode
        trackEquipment
        trackPaidBreak
        trackProject
        updatedOn
        useProjectCostCodeScoping
        webGps
        busySignInQuestion
        hideUnassignedSubprojects
        timeOffRequests
        bulletin

        subscriptionStatus {
          annualSubscriptionCount
          annualSubscriptionDate
          annualSubscriptionInterval
          annualSubscriptionPendingInvoiceId
          cardLastFour
          cardType
          couponCode
          createdOn
          customerId
          deletedOn
          exempt
          hasTrialed
          id
          nextAssessmentAt
          organizationId
          periodDay
          pricePointAction
          pricePointHandle
          productHandle
          referralCode
          status
          submittedOn
          subscribedThroughProduct
          subscriptionId
          subscriptionUpdatedAt
          trialEndedAt
          updatedOn
          userCanceled
        }
      }
      position {
        canEditPosition
        createdOn
        dailyProjectPrompts
        dailyProjectPromptsUseSubprojects
        deletedOn
        id
        level
        manageBudgets
        viewBudgets
        manageCompanySettings
        manageCostCodes
        manageEmployeeGroups
        manageEmployees
        manageEquipment
        manageMediaCollection
        manageProjectGroups
        manageProjects
        manageTimeEntries
        memberLock
        manageSchedule
        viewSchedule
        clockInRestriction
        clockInRestrictionStartTime
        organizationId
        requestSignatures
        scopeByGroup
        submittedOn
        timeEvents
        title
        updatedOn
        viewAllActivityReport
        viewEquipmentDetails
        viewEquipmentStatus
        viewMemberActivityReport
        viewMemberExpenses
        viewProjectExpenses
        canManageProjectCostCodeQuantity
        manageBulletinPosts
      }
    }
  }
`;
